import Files from './editor';

export default Files;
